import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ac7a72e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "word" }

import AppLink from '@/components/AppLink.vue';
import { useRoute } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'MemberList',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(" 保存成员列表完成后,请到 "),
    _createVNode(_component_a_button, {
      type: "link",
      class: "mod_btn_link"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_router_link, {
          to: { path: `/console/${_unref(route).params.studioId}` },
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 控制页面 ")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }),
    _createTextVNode(" 在线人数下方打开观看页显示按钮。 ")
  ]))
}
}

})